import React from "react";
import { Card, CardHeader, CardBody } from "@heroui/react";
import { Icon } from "@iconify/react/dist/iconify.js";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

type NewWorkflowCardProps = React.ComponentProps<typeof Card>;

export const NewWorkflowCard: React.FC<NewWorkflowCardProps> = (props) => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const handleOpenEdit = () => navigate(`/workflows/new/edit`);

  return (
    <Card
      isPressable
      className="py-1 hover:shadow-lg hover:scale-102 transition-all duration-200"
      onPress={handleOpenEdit}
      {...props}
    >
      <CardHeader className="pb-0 pt-2 px-4 flex-col items-start">
        <h4 className="text-brand-primary font-bold text-large text-center w-full">
          {t("workflowIndex.new_workflow", { defaultValue: "New Workflow" })}
        </h4>
        <small className="text-default-500 text-left line-clamp-2">
          {t("workflowIndex.new_workflow_desc", { defaultValue: "Create a new workflow" })}
        </small>
      </CardHeader>
      <CardBody className="overflow-visible py-2 flex items-center justify-center">
        <Icon
          className="text-brand-primary text-xl text-foreground hover:text-primary"
          height={80}
          icon="ic:baseline-add-circle-outline"
        />
      </CardBody>
    </Card>
  );
};
